/* eslint-disable @typescript-eslint/no-misused-promises */
'use client'

import { LoadingButton } from '@/components/ui/loading-button'

export const AddCartButton = ({
  loading,
  disabled,
  onClick,
  promotionModal = false,
}: {
  loading: boolean
  disabled: boolean
  onClick: () => void
  promotionModal?: boolean
}) => {
  let className =
    'add-cart-button button-color-reverse main-color-reverse bg-white w-4/5 text-base m-auto rounded-xl text-center font-bold p-3 h-[50px]'
  if (promotionModal) {
    className = 'promotion-modal-add-cart-button' + ' ' + className
  }
  return (
    <div className="w-full">
      <LoadingButton
        className={className}
        onClick={onClick}
        loading={loading}
        disabled={disabled}
      >
        カートに追加
      </LoadingButton>
    </div>
  )
}
